import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

export const useCreateDraftJobPost = () => {
  return useMutation({
    mutationKey: ['createDraftJobPost'],
    mutationFn: PermanentJobsService.createDraftJobPost,
  });
};
